import React from 'react';

import { colorsPalette } from '../../theme';

const RenewIcon = (props) => {
  const color = props?.color || colorsPalette.white;

  return (
    <svg
      viewBox="0 0 24 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      color={color}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.40803 9.63307C2.40803 4.31282 6.72085 0 12.0411 0C16.5385 0 20.3051 3.08663 21.3659 7.25368C21.2692 7.23765 21.1717 7.2248 21.0722 7.2248C20.7523 7.2248 20.4484 7.31431 20.1783 7.46963C19.2194 3.86889 15.9401 1.20413 12.0411 1.20413C7.39362 1.20413 3.61221 4.98554 3.61221 9.63307C3.61221 9.69986 3.61835 9.76507 3.6245 9.83033C3.62865 9.87451 3.63281 9.9187 3.63507 9.96341L4.99292 8.60556C5.2281 8.37033 5.60905 8.37033 5.84424 8.60556C6.07946 8.84074 6.07946 9.22169 5.84424 9.45687L3.43597 11.8651C3.31838 11.9827 3.16419 12.0413 3.0101 12.0413C2.85601 12.0413 2.70187 11.9827 2.58465 11.8651L0.176387 9.45687C-0.0587956 9.22169 -0.0587956 8.84079 0.176387 8.60556C0.411569 8.37033 0.792471 8.37033 1.0277 8.60556L2.42689 10.0048C2.42551 9.98438 2.42406 9.96404 2.42262 9.9437C2.41532 9.84069 2.40803 9.738 2.40803 9.63307ZM21.592 10.4988C21.592 15.819 17.2791 20.1318 11.9589 20.1318C7.46146 20.1318 3.69492 17.0452 2.63406 12.8781C2.73076 12.8942 2.82832 12.907 2.92785 12.907C3.24774 12.907 3.5516 12.8175 3.82173 12.6622C4.78061 16.2629 8.05986 18.9277 11.9589 18.9277C16.6064 18.9277 20.3878 15.1463 20.3878 10.4988C20.3878 10.432 20.3816 10.3668 20.3755 10.3015C20.3713 10.2573 20.3672 10.2131 20.3649 10.1684L19.0071 11.5263C18.7719 11.7615 18.3909 11.7615 18.1558 11.5263C17.9205 11.2911 17.9205 10.9101 18.1558 10.675L20.564 8.26669C20.6816 8.1491 20.8358 8.0905 20.9899 8.0905C21.144 8.0905 21.2981 8.1491 21.4153 8.2667L23.8236 10.675C24.0588 10.9101 24.0588 11.291 23.8236 11.5263C23.5884 11.7615 23.2075 11.7615 22.9723 11.5263L21.5731 10.1271C21.5745 10.1475 21.5759 10.1678 21.5774 10.1882C21.5847 10.2912 21.592 10.3938 21.592 10.4988Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default RenewIcon;
